import $ from 'jquery';

const appLink = () => {
  const link = $('[data-android][data-ios]');
  const wrapper = $('.c-main-nav__bottom');

  if (link.length) {
    let url = '';
    if (
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      url = link.data('ios');
    }
    if (navigator.userAgent.match(/android/i)) {
      url = link.data('android');
    }
    if (url.length) {
      link.attr('href', url);
    } else {
      wrapper.addClass('desktop');
    }
  }
};
export default appLink;



// WEBPACK FOOTER //
// ./src/scripts/modules/app-link.js